import React, { useEffect, useMemo, useRef, useState } from "react";

export default function ColorPlatete() {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState<string | null>(null);
    const rootRef = useRef<HTMLDivElement | null>(null);

    const THEME_BASES = [  
        "#E7E6E6", // Light 2
        "#000000", // Dark 1
        "#44546A", // Dark 2
        "#5B9BD5", // Accent 1
        "#ED7D31", // Accent 2
        "#A5A5A5", // Accent 3
        "#FFC000", // Accent 4
        "#4472C4", // Accent 5
        "#70AD47", // Accent 6
    ];

    // ---------- color utils ----------
    const clamp = (n: number) => Math.max(0, Math.min(255, Math.round(n)));

    const hexToRgb = (hex: string) => {
        const h = hex.replace("#", "");
        const n = parseInt(h, 16);
        return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    };

    const rgbToHex = (r: number, g: number, b: number) =>
        `#${[r, g, b].map((x) => clamp(x).toString(16).padStart(2, "0")).join("")}`;

    const mix = (a: string, b: string, t: number) => {
        const A = hexToRgb(a);
        const B = hexToRgb(b);
        return rgbToHex(
            A.r + (B.r - A.r) * t,
            A.g + (B.g - A.g) * t,
            A.b + (B.b - A.b) * t
        );
    };

    const buildColumn = (base: string) => {
        const tints = [0.85, 0.65, 0.45].map((t) => mix(base, "#FFFFFF", t));
        const shades = [0.35, 0.55, 0.75].map((t) => mix(base, "#000000", t));
        return [base, ...tints, ...shades];
    };

    const columns = useMemo(
        () => THEME_BASES.map((b) => buildColumn(b)),
        []
    );

    useEffect(() => {
        const close = (e: MouseEvent) => {
            if (!rootRef.current?.contains(e.target as Node)) setOpen(false);
        };
        document.addEventListener("mousedown", close);
        return () => document.removeEventListener("mousedown", close);
    }, []);

    return (
        <div ref={rootRef} style={{ position: "relative", display: "inline-block" }}>

            <button onClick={() => setOpen((v) => !v)}  style={{ padding: "14px 20px", borderRadius: 14, border: "1px solid #CBD5E1", background: selected ?? "#FFFFFF", fontSize: 14, fontWeight: 100, cursor: "pointer", }}  >
                Theme Color ▾
            </button>
 
            {open && (
                <div style={{
                        position: "absolute",
                        top: "110%",
                        left: "90%",
                        transform: "translateX(-50%)",
                        background: "#FFF",
                        border: "1px solid #CBD5E1",
                        borderRadius: 20,
                        padding: 24,
                        boxShadow: "0 30px 60px rgba(0,0,0,0.15)",
                        width: "460% !important",
                    }}
                >
                    <div style={{ fontSize: 15, fontWeight: 100, marginBottom: 16 }} className="ws-12 text-bold"> Theme Colors </div>
                    <hr className="ws-12"></hr>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${columns.length}, 44px)`,
                            gap: 14,
                        }} className="ws-12"
                    >
 

                        {columns.map((col, i) => (
                            <div key={i} style={{ borderRadius: 10, overflow: "hidden", border: "1px solid #E5E7EB", }}  >
                                {col.map((hex) => (
                                    <div
                                        key={hex}
                                        onClick={() => { setSelected(hex); setOpen(false); }}
                                        style={{
                                            height: 34,
                                            background: hex,
                                            cursor: "pointer",
                                            outline: selected === hex ? "2px solid #111827" : "none",
                                            outlineOffset: "-2px",
                                        }}
                                    />
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
